<!-- Redefine Header -->
<app-redefine-header></app-redefine-header>

<!-- Hero Section -->
<section class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
        <div class="hero-banner-content">
            <div class="banner-row">
                <div class="before-title">
                    <div class="before-title-line"></div>
                </div>
                <div class="banner-title">
                    <span class="title-text">Find your perfect</span>
                    <span class="title-text">parking spot today.</span>
                </div>
            </div>
            <div class="hero-buttons">
                <button (click)="viewAllProperties()" class="btn-learn-more">
                    <span class="btn-text">Find Parking</span>
                </button>
                <button (click)="scrollToSection('how-it-works')" class="btn-scroll">
                    <span class="btn-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="#ffffff" viewBox="0 0 256 256">
                            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm37.66-85.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,148.69V88a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,130.34Z"></path>
                        </svg>
                    </span>
                    <span class="btn-text">Learn More</span>
                </button>
            </div>
        </div>
    </div>
</section>

<!-- Properties Section -->
<section class="properties-section" id="properties">
    <div class="container">
        <div class="section-header">
            <div>
                <span class="section-accent"></span>
                <p class="section-eyebrow">A well-located</p>
                <h2>High-quality and efficient local property portfolio</h2>
            </div>
            <a (click)="viewAllProperties()" class="view-all-link">
                View all properties
                <span class="link-icon"><i class="fa-solid fa-arrow-right"></i></span>
            </a>
        </div>

        <div class="properties-grid" *ngIf="!loadingParkings && featuredParkings.length > 0">
            <div class="property-card" *ngFor="let parking of featuredParkings" (click)="viewProperty(parking)">
                <div class="property-image">
                    <img [src]="getParkingImage(parking)" [alt]="parking.title" />
                    <span class="property-badge" *ngIf="parking.parkingLocation?.suburb">{{ parking.parkingLocation.suburb }}</span>
                </div>
                <div class="property-content">
                    <h3 class="property-title">{{ parking.title }}</h3>
                    <div class="property-meta">
                        <span class="meta-item">
                            <i class="fa-solid fa-location-dot"></i>
                            {{ parking.parkingLocation?.fullAddress || 'Location available on request' }}
                        </span>
                        <span class="meta-item">
                            <i class="fa-solid fa-car"></i>
                            {{ parking.numberOfBays || 0 }} bays
                        </span>
                    </div>
                    <div class="property-footer">
                        <span class="property-price">{{ formatPrice(parking.defaultPriceInCents) }}/month</span>
                        <a class="view-link">View <span class="link-icon"><i class="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="properties-loading" *ngIf="loadingParkings">
            <div class="loading-spinner"></div>
            <p>Loading properties...</p>
        </div>

        <div class="properties-empty" *ngIf="!loadingParkings && featuredParkings.length === 0">
            <i class="fa-solid fa-building"></i>
            <h3>Properties coming soon</h3>
            <p>We're currently onboarding premium parking locations. Contact us to learn more.</p>
            <a class="btn-secondary" routerLink="/contact">Get in touch</a>
        </div>
    </div>
</section>

<!-- How It Works Section -->
<section class="how-it-works-section" id="how-it-works">
    <div class="container">
        <div class="section-header centered">
            <span class="section-accent"></span>
            <h2>How it works</h2>
            <p class="section-subtitle">Secure your parking bay in three simple steps</p>
        </div>

        <div class="steps-grid">
            <div class="step-card">
                <div class="step-icon">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </div>
                <h3>Find your space</h3>
                <p>Browse our portfolio of premium parking locations across South Africa.</p>
            </div>

            <div class="step-card">
                <div class="step-icon">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <h3>Submit your request</h3>
                <p>Select your preferred bay and duration. We'll handle the paperwork.</p>
            </div>

            <div class="step-card">
                <div class="step-icon">
                    <i class="fa-solid fa-check-circle"></i>
                </div>
                <h3>Start parking</h3>
                <p>Receive confirmation within 24 hours and access your dedicated bay.</p>
            </div>
        </div>

        <div class="cta-row">
            <a (click)="viewAllProperties()" class="btn-secondary">View properties</a>
            <a routerLink="/contact" class="btn-outline">Get in touch</a>
        </div>
    </div>
</section>

<!-- Value Section -->
<section class="value-section">
    <div class="container">
        <div class="value-grid">
            <div class="value-content">
                <span class="section-accent"></span>
                <h2>Redefine Properties</h2>
                <p>
                    Redefine's internally managed local property portfolio comprises premium retail, office and industrial properties that are strategically spread across South Africa's major metropolitan areas. Our parking solutions are designed with the commitment to provide quality, accessibility and value for our stakeholders.
                </p>
                <ul class="value-list">
                    <li>
                        <i class="fa-solid fa-shield-halved"></i>
                        <span>24/7 security and access control</span>
                    </li>
                    <li>
                        <i class="fa-solid fa-clock"></i>
                        <span>Flexible monthly terms</span>
                    </li>
                    <li>
                        <i class="fa-solid fa-building"></i>
                        <span>Prime locations in premium properties</span>
                    </li>
                    <li>
                        <i class="fa-solid fa-headset"></i>
                        <span>Dedicated support team</span>
                    </li>
                </ul>
                <a routerLink="/contact" class="btn-secondary">Learn more</a>
            </div>
            <div class="value-image">
                <img src="/assets/images/parking/parking-monthly.png" alt="Premium parking solutions" />
            </div>
        </div>
    </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
    <div class="container">
        <div class="cta-content">
            <h2>Ready to secure your parking?</h2>
            <p>Get in touch with our team to find the perfect parking solution for your needs.</p>
            <div class="cta-actions">
                <a routerLink="/contact" class="btn-cta-primary">Contact us</a>
                <a (click)="viewAllProperties()" class="btn-cta-inverse">View properties</a>
            </div>
        </div>
    </div>
</section>

<!-- Redefine Footer -->
<app-redefine-footer></app-redefine-footer>

